function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "e-apm\\u0101c\\u012Bba",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "02.-E---apm\\u0101c\\u012Bba---S\\u0101kums-(-piekt\\u0101-nodarb\\u012Bba)",
  transform: "translate(-508.000000, -209.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Content",
  transform: "translate(294.000000, 80.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Sessions",
  transform: "translate(24.000000, 129.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: 4,
  transform: "translate(168.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(22.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "path",
  fill: "#FFFFFF",
  cx: 5,
  cy: 5,
  r: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M5,0 C7.76142375,0 10,2.23857625 10,5 C10,7.76142375 7.76142375,10 5,10 C2.23857625,10 0,7.76142375 0,5 C0,2.23857625 2.23857625,0 5,0 Z M8.17061488,2.94049623 C7.97034601,2.74022737 7.65521765,2.72482207 7.43727809,2.89428034 L7.38494068,2.94049623 L4.44444444,5.88055556 L3.72617043,5.16271845 L3.67383302,5.11650256 C3.45589346,4.94704429 3.1407651,4.96244959 2.94049623,5.16271845 C2.74022737,5.36298732 2.72482207,5.67811569 2.89428034,5.89605525 L2.94049623,5.94839266 L4.05160734,7.05950377 L4.10394475,7.10571966 C4.30372268,7.26105641 4.58516621,7.26105641 4.78494414,7.10571966 L4.83728155,7.05950377 L8.17061488,3.72617043 L8.21683077,3.67383302 C8.38628904,3.45589346 8.37088375,3.1407651 8.17061488,2.94049623 Z",
  id: "icon",
  fill: "#2C9C3B"
})))))));

function SvgIcSmallCheckXs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "22708D00-A519-4FD0-9173-1BA4CC2367A5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSmallCheckXs);
export default __webpack_public_path__ + "static/media/ic-small-check-xs.8cfd5064.svg";
export { ForwardRef as ReactComponent };